<template>
  <VModal :showing="showing" container-classes="max-w-screen-sm" @close="handleClose(false)" @update:showing="updateShowing">
    <div class="flex items-start mb-8">
      <span class="mr-4 rounded-full bg-red-100 w-10 h-10 grid place-items-center flex-shrink-0">
        <ExclamationTriangleIcon class="h-6 inline text-red-800" />
      </span>
      <div>
        <h2 class="text-xl mb-4 mr-6">
          <template v-if="!deck.archived"> Archive {{ deck.title }}?</template>
          <template v-else> Unarchive {{ deck.title }}?</template>
        </h2>
        <p class="text-gray-800 font-light">
          <template v-if="!deck.archived">
            This 3D Presentation will be archived, which means it will not be visible on the company profile page or searchable in Discover. It may
            still be accessed via direct link.
          </template>
          <template v-else>
            This 3D Presentation will be unarchived, which means it will be visible on the company profile page and searchable in Discover.
          </template>
        </p>
        <p class="mt-4 text-gray-800 font-light">Are you sure you want to continue?</p>
      </div>
    </div>
    <div class="flex justify-end gap-3">
      <VButton size="sm" @click="$emit('cancel'), handleClose(false)">Cancel</VButton>
      <VButton variant="danger" size="sm" @click="$emit('archive'), handleClose(false)">Confirm</VButton>
    </div>
  </VModal>
</template>

<script lang="ts" setup>
import type { PropType, DeepReadonly } from 'vue'
import { defineComponent, ref, watch } from 'vue'
import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline'
import type { EditDeck } from '@/composables/useEditDeck'

defineProps({
  deck: {
    type: Object as PropType<DeepReadonly<EditDeck>>,
    required: true,
  },
  showing: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['update:showing', 'archive', 'cancel'])

function handleClose(showing: boolean) {
  emit('update:showing', showing)
}

function updateShowing(showing: boolean) {
  handleClose(showing)
  if (!showing) emit('cancel')
}
</script>
